import * as React from "react";
const SvgFiRrOtter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-otter_svg__a)">
      <path
        fill="#062147"
        d="M24 13.5V15c0 2.195-.799 4.31-2.25 5.953a1 1 0 0 1-1.412.088 1 1 0 0 1-.088-1.412A6.98 6.98 0 0 0 22 15v-1.5q0-.49-.018-.949C20.892 13.482 19.417 14 18 14a1 1 0 1 1 0-2c1.626 0 3.356-1.018 3.627-2.574-.52-2.616-1.401-3.792-1.413-3.808a1.003 1.003 0 0 1 .172-1.4.997.997 0 0 1 1.396.158c.06.076 1.347 2.394 1.869 4.98.21 1.159.35 2.535.35 4.145zm-5.445 2.668a1 1 0 0 1 .277 1.387c-.665.998-.804 1.992-.827 3.479-.026 1.636-1.372 2.967-2.999 2.967H10c-4.963 0-9-4.038-9-9v-4.514a4.23 4.23 0 0 1-1-2.736V6.418c0-1.263.498-2.666 1.035-3.49a1.5 1.5 0 1 1 1.891-1.893A6.4 6.4 0 0 1 6.417 0h2.166c1.286 0 2.485.381 3.491 1.035a1.5 1.5 0 1 1 1.891 1.891A6.4 6.4 0 0 1 15 6.416v1.333c0 1.27-.56 2.412-1.447 3.191C14.999 12.346 15 14.941 15 15.999a1 1 0 1 1-2 0c0-3.691-1-4-2.25-4a4.24 4.24 0 0 1-3.25-1.514A4.24 4.24 0 0 1 3 11.811v.188c0 2.897 2.523 5 6 5a1 1 0 1 1 0 2c-2.28 0-4.279-.752-5.709-2.003.862 2.89 3.544 5.003 6.709 5.003h5.006c.542 0 .99-.448.999-.999.023-1.457.133-3.009 1.163-4.556a1 1 0 0 1 1.387-.276M4.25 10a2.253 2.253 0 0 0 2.247-2.136A.999.999 0 0 1 7 6h1a1 1 0 0 1 .503 1.864A2.253 2.253 0 0 0 10.75 10C11.99 10 13 8.991 13 7.75V7h-1.5a1 1 0 1 1 0-2h1.267a4.425 4.425 0 0 0-4.184-3H6.417a4.425 4.425 0 0 0-4.184 3H3.5a1 1 0 1 1 0 2H2v.75C2 8.991 3.01 10 4.25 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-otter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOtter;
